export const environment = {
  production: false,
  // LIve URL because it references this for production
  signupBaseUrl: 'https://signup-lriaqt4o7q-uc.a.run.app'
};
